import { useReducer } from "react";
import _isNil from "lodash/isNil";

const actions = {
    blur: "BLUR",
    reset: "RESET",
    input: "INPUT"
}

const inputStateReducer = (state: any, action: any) => {
    switch (action.type) {
        case actions.input:
            return {
                ...state,
                value: action.value
            };

        case actions.blur:
            return {
                ...state,
                isTouched: true
            };

        case actions.reset:
            return {
                ...state,
                value: state.initialValue,
                isTouched: false, hasError:
                    false
            };

        default:
            break;
    }

    return inputStateReducer;
};

const useInput = (validateValue: any, options: any | null = null) => {

    let { initialValue } = options ?? {};

    const hasInitialValue = !_isNil(initialValue);

    initialValue = hasInitialValue ? initialValue : "";

    const initialState = { value: initialValue, isTouched: false, initialValue: initialValue }

    const [inputState, dispatch] = useReducer(
        inputStateReducer,
        initialState
    );

    const valueIsValid = validateValue(inputState.value);

    const hasError = !valueIsValid && inputState.isTouched;

    const setValue = (value: any) => dispatch({ type: actions.input, value: value });

    const valueChangeHandler = (event: any) => dispatch({ type: actions.input, value: event.target.value });

    const inputBlurHandler = (event: any) => dispatch({ type: actions.blur });

    const reset = () => dispatch({ type: actions.reset });

    return {
        ...options,
        value: inputState.value,
        isValid: valueIsValid,
        isTouched: inputState.isTouched,
        hasError,
        valueChangeHandler,
        inputBlurHandler,
        setValue,
        reset
    };
};

export default useInput;
